<template>
  <section class="flex z-10 flex-col py-14 px-6 w-full bg-white max-md:px-5">
    <h2
      class="self-center text-4xl tracking-wider leading-9 text-center text-neutral-800 max-md:max-w-full"
    >
      {{ content.heading }}
    </h2>
    <div class="mt-20 max-md:mt-10">
      <div
        class="grid gap-8 max-md:grid-cols-1 max-lg:grid-cols-2"
        :class="`grid-cols-${content.Icons?.length || 4}`"
      >
        <div
          v-for="(icon, index) in content.Icons"
          :key="index"
          class="flex flex-col items-center"
        >
          <div class="flex flex-col text-sm text-center text-neutral-800">
            <img
              v-if="icon.image?.url"
              loading="lazy"
              :src="useStrapiMedia(icon.image.url)"
              :alt="icon.heading + ' icon'"
              class="self-center aspect-square w-[69px] mb-4"
            />
            <div class="mt-1.5 leading-5">
              <span class="font-semibold">{{ icon.heading }}</span
              ><br />
              <span class="text-neutral-800">{{ icon.content }}</span>
            </div>
            <p v-if="icon.additionalContent" class="mt-6 leading-[150%]">
              {{ icon.additionalContent }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const props = defineProps({
  content: {
    type: Object,
    required: true,
  },
});

// console.log("IconGrid props :", props);
// console.log("IconGrid Icons:", props.content.Icons);
// // Her bir icon için detaylı log
// props.content.Icons?.forEach((icon: any, index: number) => {
//   console.log(`Icon ${index}:`, icon);
//   console.log(`Icon ${index} image:`, icon.image);
//   if (icon.image) {
//     console.log(`Icon ${index} image url:`, icon.image.url);
//   }
// });
</script>
